import * as firebase from 'firebase'

import QueryBuilder from './QueryBuilder'

const EstimatesRepository = {
  
  createNewEstimate: (teamId, estimate, items) => {
    const updates = {}

    // Create estimate entity
    const estimatesPath = `estimates/${teamId}`
    const estimatesRef = firebase.database().ref(estimatesPath)
    const estimateDbKey = estimatesRef.push().key
    estimate.id = estimateDbKey
    updates[`${estimatesPath}/${estimateDbKey}`] = estimate

    // Create estimate items entities    
    const estimateItemsPath = `estimate_items/${teamId}/${estimate.id}`
    const estimateItemsRef = firebase.database().ref(estimateItemsPath)
    for (const item of items) {
      const itemDbKey = estimateItemsRef.push().key
      item.id = itemDbKey
      item.estimateId = estimate.id
      updates[`${estimateItemsPath}/${itemDbKey}`] = item
    }

    return firebase.database().ref().update(updates)
  },

  updateEstimateTotal: (teamId, estimate, total) => {
    const estimateTotalPath = `estimates/${teamId}/${estimate.id}/total`
    firebase.database().ref(estimateTotalPath).set(total)
  },

  addEstimateItem: (teamId, estimate, item) => {
    const estimateItemsPath = `estimate_items/${teamId}/${estimate.id}`
    const estimateItemsRef = firebase.database().ref(estimateItemsPath)
    const itemDbKey = estimateItemsRef.push().key
    item.id = itemDbKey
    item.estimateId = estimate.id
    firebase.database().ref(`${estimateItemsPath}/${itemDbKey}`).set(item)
  },

  deleteEstimateItem: (teamId, estimate, item) => {
    const itemPath = `estimate_items/${teamId}/${estimate.id}/${item.id}`
    firebase.database().ref(itemPath).remove()
  },

  updateItem: (teamId, estimate, item) => {
    const itemPath = `estimate_items/${teamId}/${estimate.id}/${item.id}`
    firebase.database().ref(itemPath).set(item)
  },

  addEstimatesListListener: (teamId, filters, listener) => {
    const query = QueryBuilder.buildEstimatesListQuery(teamId, filters)
    return query.on('value', listener)
  },

  removeEstimatesListListener: (teamId, filters, listener) => {
    const query = QueryBuilder.buildEstimatesListQuery(teamId, filters)
    return query.off('value', listener)
  },

  addEstimateListener: (teamId, estimateId, listener) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimateId}`)
      .on('value', listener)
  },

  removeEstimateListener: (teamId, estimateId, listener) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimateId}`)
      .off('value', listener)
  },

  addEstimateItemsListener: (teamId, estimateId, listener) => {
    return firebase.database()
      .ref(`estimate_items/${teamId}/${estimateId}`)
      .on('value', listener)
  },

  removeEstimateItemsListener: (teamId, estimateId, listener) => {
    return firebase.database()
      .ref(`estimate_items/${teamId}/${estimateId}`)
      .off('value', listener)
  },

  addCustomerListener: (teamId, customerId, listener) => {
    return firebase.database()
      .ref(`customers/${teamId}/${customerId}`)
      .on('value', listener)
  },

  removeCustomerListener: (teamId, customerId, listener) => {
    return firebase.database()
      .ref(`customers/${teamId}/${customerId}`)
      .off('value', listener)
  },

  updateEstimateCustomerInfo: (teamId, estimate, customerInfo) => {
    const updates = {}
    const base = `estimates/${teamId}/${estimate.id}`
    updates[`${base}/customerId`] = customerInfo.customerId
    updates[`${base}/contactId`] = customerInfo.contactId
    updates[`${base}/customerName`] = customerInfo.customer && customerInfo.customer.name || ''
    firebase.database().ref().update(updates)
  },

  deleteEstimate: (teamId, estimate) => {
    const tasks = []
    tasks.push(firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}`)
      .remove())
    tasks.push(firebase.database()
      .ref(`estimate_items/${teamId}/${estimate.id}`)
      .remove())
    return Promise.all(tasks)
  },

  setEstimateNumber: (teamId, estimate, number) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}/number`)
      .set(number)
  },

  setEstimateTitle: (teamId, estimate, title) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}/title`)
      .set(title)
  },
  
  setEstimateDate: (teamId, estimate, estimateDate) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}/estimateDate`)
      .set(estimateDate)
  },

  setEstimateNotes: (teamId, estimate, notes) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}/notes`)
      .set(notes)
  },

  setEstimatePaymentDueDate: (teamId, estimate, paymentDueDate) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimate.id}/paymentDueDate`)
      .set(paymentDueDate)
  },

  getLastEstimate: (teamId, onEstimateValue) => {
    return firebase.database()
      .ref(`estimates/${teamId}`)
      .limitToLast(1)
      .once('value')
      .then(onEstimateValue)
  },

  getEstimate: (teamId, estimateId) => {
    return firebase.database()
      .ref(`estimates/${teamId}/${estimateId}`)
      .once('value')
      .then(snapshot => snapshot && snapshot.val())
  },

  updateEstimateStatusOnEmailSent: (teamId, estimateId) => {
    // If the estimate status is draft, set it to sent, do nothing otherwise.
    return EstimatesRepository.getEstimate(teamId, estimateId)
      .then(estimate => {
        if (estimate.status === 'draft') {
          return firebase.database()
            .ref(`estimates/${teamId}/${estimateId}/status`)
            .set('sent')
        }
        return Promise.resolve(0)
      })
  }
  
}

export default EstimatesRepository



// WEBPACK FOOTER //
// ./src/billing/infra/EstimatesRepository.js